export default __webpack_public_path__ + "static/media/new-17.87aa0ebb.png";